import * as React from "react";
import { ContentPicker } from "../components/ContentPicker";
import { ContentViewModel, ListContent, ImageTypes, EntityTypes } from "../content/ContentStore";

const MatchSplashPicker = ({ onSelect, disabled, uri }) => {
    const [options, setOptions] = React.useState([] as ContentViewModel[]);

    React.useEffect(() => {
        ListContent(ImageTypes.Splash, EntityTypes.Match, 0, 50).then((res) => {
            setOptions(res.result);
        });
    }, []);
    
    return (
        <ContentPicker
            label="Splash"
            onSelect={onSelect}
            uri={uri}
            width="300px"
            options={options}
            optionWidth="256px"
            optionHeight=""
            optionsPageSize={3}
            suggestedSize="16:9 > 600px wide"
            disabled={disabled}
        ></ContentPicker>
    );
};

export default MatchSplashPicker;
